import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20beauty%20pageant%20stage%20with%20crimson%20velvet%20curtains%2C%20golden%20spotlights%20and%20empty%20stage%20floor%2C%20editorial%20cinematic%20photography%2C%20deep%20shadows%20and%20warm%20amber%20highlights%2C%20moody%20atmosphere%2C%20no%20people&width=1800&height=1000&seq=pageant-hero-main&orientation=landscape"
          alt="选美比赛舞台与聚光灯 - 吃瓜深扒社赛果解析专题配图"
          title="选美吃瓜 - 赛果背后的门道"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/25"></div>

      <div className="relative mx-auto w-full px-4 pb-14 pt-16 md:px-6 md:pb-20 md:pt-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 font-label text-xs tracking-wide text-white backdrop-blur">
            <i className="ri-eye-line" aria-hidden="true"></i>
            选美吃瓜 · 赛果深扒
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-white md:text-5xl">
            选美结果有内幕？
            <br />
            把评分表摊开，逐行看名次是怎么被改写的
          </h1>
          <p className="mt-6 max-w-2xl text-sm leading-loose text-white/85 md:text-base">
            吃瓜深扒社聚焦选美吃瓜内定与黑幕，整理评委评分猫腻、幕后交易线索与爆冷瞬间。我们不靠转述，而是把公开可查的评分口径、评委构成与计分流程摆上台面，帮你理清赛果背后的门道。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-file-search-line" aria-hidden="true"></i>
              查看爆料专题
            </Link>
            <a
              href="#method"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-white/40 px-6 py-3 font-label text-sm font-medium text-white transition-colors hover:bg-white/10 whitespace-nowrap"
            >
              <i className="ri-check-double-line" aria-hidden="true"></i>
              了解核对方法
            </a>
          </div>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-6 border-t border-white/20 pt-8 md:grid-cols-4">
          {siteInfo.stats.map((stat) => (
            <div key={stat.label}>
              <dt className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">{stat.value}</dt>
              <dd className="mt-1 text-xs text-white/70 md:text-sm">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}